import validate from './validate';

export default (delay) => {
  if (delay) {
    setTimeout(validate, delay);
  } else {
    validate();
  }
};
